import { render, staticRenderFns } from "./Kta.vue?vue&type=template&id=18a9e001&"
import script from "./Kta.vue?vue&type=script&lang=js&"
export * from "./Kta.vue?vue&type=script&lang=js&"
import style0 from "./Kta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports